require('./creditPregrantedLimitVariationView.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
//@actions
const CreditPregrantedLimitVariationActions = require('actions/credits/creditPregrantedLimitVariation');
//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const { AmountInput } = require('commonsComponents/amountInput');
//@components
const CreditPregrantedLimitVariationStep = require('components/credits/creditPregrantedLimitVariationStep/creditPregrantedLimitVariationStep');
const CreditPregrantedLimitVariationSuccess = require('components/credits/creditPregrantedLimitVariationSuccess/creditPregrantedLimitVariationSuccess');
const CreditPregrantedLimitVariationFailure = require('components/credits/creditPregrantedLimitVariationFailure/creditPregrantedLimitVariationFailure');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
//@utilities
const { formatText, FormattedText, getLanguage, getFinalTitle } = require('core/i18n').i18n;
const { getCurrencySymbol } = require('utilities/currencyHelper');
const { getLastNChars } = require('utilities/stringHelper');
//@constants
const { CREDIT_PREGRANTED_VARIATION_LIMIT } = require('constants/operationTypes');
const { API_ENTERPRISE_NUMBER, API_CENTER, GRAPHIC_TUTOR_TYPE_4 } = require('constants/index');

class CreditPregrantedLimitVariationView extends React.Component {

    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.setLimit = this.setLimit.bind(this);
    }

    componentDidMount() {
        const { match: { params: { creditId } }, immCredits, history } = this.props;
        const immCredit = immCredits.getIn(['byId', creditId]);

        if (!immCredit.has('details')) {
            history.push(`/myprofile/loans-mortgages/credit/pregranted-credit/${creditId}`);
        }
    }

    componentWillUnmount() {
        this.props.clear();
    }

    setLimit(value) {
        this.props.setLimit(value);
    }

    buildError() {
        return (
            <div className="card-modify-limit__operation-result-state">
                <CreditPregrantedLimitVariationFailure />
            </div>
        );
    }

    buildSuccess(immCredit, newLimit) {
        return (
            <div className="card-modify-limit__operation-result-state">
                <CreditPregrantedLimitVariationSuccess immCredit={immCredit} newLimit={newLimit} />
            </div>
        );
    }

    buildWizard(immCredit, immPregrantedCreditLimitVariation) {
        const { validateStep, setVisibleStep, immAccounts } = this.props;

        const immAccount = immAccounts.get('byId').get(immCredit.get('accountId'));
        const immSteps = immPregrantedCreditLimitVariation.get('steps');
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel: this.handleCancel,
            finish: this.handleFinish
        };

        const currency = immCredit.getIn(['available', 'currency']);
        const currencySign = getCurrencySymbol(immCredit.get('available'));

        const newLimit = immPregrantedCreditLimitVariation.get('newLimit');
        const errorLimitIsVisible = !immPregrantedCreditLimitVariation.getIn(['steps', 0, 'valid']) && immPregrantedCreditLimitVariation.get('newLimitIsDirty')
        const errorLimitValidationMsg = formatText('creditPregrantedLimitVariationStep-validationMsg', [immCredit.getIn(['available', 'amount'])]);

        const operationParams = {
            currency,
            originAccount: API_ENTERPRISE_NUMBER + API_CENTER + immCredit.get('product') + immCredit.get('contractNumber'),
            ammount: newLimit
        };
        return (
            <Wizard
                fullWidth={true}
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={immPregrantedCreditLimitVariation.get('visibleStep')}
                showPreLeaveModal={true}
            >
                <WizardStep position="first" cancelButton={true} >
                    <CreditPregrantedLimitVariationStep
                        immCredit={immCredit}
                        immAccount={immAccount}
                        titleKey="creditPregrantedLimitVariationStep-stepOneTitle"
                    >
                        <section className="credit-pregranted-limit-variation__input-section">
                            <FormattedText
                                className="credit-pregranted-limit-variation__input-subtitle"
                                value="creditPregrantedLimitVariationStep-newLimit"
                            />
                            <div className="credit-pregranted-limit-variation__input">
                                <AmountInput
                                    id="inp_creditPregrantedLimitStepOne_newLimit"
                                    amount={newLimit}
                                    callback={this.setLimit}
                                    error={errorLimitIsVisible}
                                    errorMsg={errorLimitValidationMsg}
                                    showBlurZero
                                    hideFocusZero
                                    disablePaste
                                    language={getLanguage()}
                                />
                            </div>
                            <span className="credit-pregranted-limit-variation__currency-sign">
                                {currencySign}
                            </span>
                        </section>
                    </CreditPregrantedLimitVariationStep>
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton={true}
                    addLoadingBehaviour={true}
                    immFinalButton="common-confirm"
                    isLoading={immPregrantedCreditLimitVariation.get('inProgress')}
                >
                    <CreditPregrantedLimitVariationStep
                        immCredit={immCredit}
                        immAccount={immAccount}
                        showNewLimitField={true}
                        newLimit={newLimit}
                        titleKey="creditPregrantedLimitVariationStep-stepTwoTitle"
                        subtitleKey="creditPregrantedLimitVariationStep-checkDataSubtitle"
                    >
                        <section className="credit-pregranted-limit-variation__input-section credit-pregranted-limit-variation__input-section--signature-pattern">
                            <SignaturePattern
                                operationType={CREDIT_PREGRANTED_VARIATION_LIMIT}
                                operationParams={operationParams}
                            />
                        </section>
                    </CreditPregrantedLimitVariationStep>
                </WizardStep>
            </Wizard>
        );
    }

    handleCancel() {
        const { creditId } = this.props.match.params;
        this.props.history.push(`/myprofile/loans-mortgages/credit/pregranted-credit/${creditId}`);
    }

    handleFinish() {
        const { match: { params: { creditId } }, setNewLimit } = this.props;
        setNewLimit(creditId);
    }

    render() {
        const { match: { params: { creditId } }, immCredits, immPregrantedCreditLimitVariation } = this.props;
        const immCredit = immCredits.getIn(['byId', creditId]);
        let bodyContent;

        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-loansAndMortgages'),
                url: '/myprofile/loans-mortgages'
            },
            {
                text: formatText('breadcrumb-pregrantedCredit', [getLastNChars(immCredit.get('iban'), 4, '.', 4)]),
                url: `/myprofile/loans-mortgages/credit/pregranted-credit/${creditId}`
            },
            {
                text: formatText('breadcrumb-creditsPregrantedModifyLimit'),
                url: `/myprofile/loans-mortgages/credits/${creditId}/credit-pregranted-modify-limit`

            }
        ];
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_4}
                title={formatText('tutorials-loansLimitTitle')}
            />
        );

        if (immCredit) {
            if (immPregrantedCreditLimitVariation.get('error')) {
                bodyContent = this.buildError();
            } else if (immPregrantedCreditLimitVariation.get('success')) {
                bodyContent = this.buildSuccess(immCredit, immPregrantedCreditLimitVariation.get('newLimit'));
            } else {
                bodyContent = this.buildWizard(immCredit, immPregrantedCreditLimitVariation);
            }
        }

        let content = <LoadingSection />;

        content = (
            <article className="credit-pregranted-limit-variation">
                <OKCover size="medium" section="loansmortgages">
                    <OKHeaderSubPage
                        breadcrumbConfig={mappingBreadcrumb}
                        tutorial={tutorial}
                        finalTitle={getFinalTitle('creditPregrantedLimitVariation-title')}
                    />
                </OKCover>
                <section className="credit-pregranted-limit-variation__body">
                    {bodyContent}
                </section>
            </article>
        );

        return content;
    }
}

CreditPregrantedLimitVariationView.propTypes = {
    history: PropTypes.object.isRequired,
    immCredits: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    setLimit: PropTypes.func.isRequired,
    clear: PropTypes.func.isRequired,
    setNewLimit: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    immPregrantedCreditLimitVariation: PropTypes.object.isRequired
};

module.exports.constructor = CreditPregrantedLimitVariationView;
module.exports.CreditPregrantedLimitVariationView = connect(state => ({
    immCredits: state.creditsPregranted,
    immAccounts: state.accounts,
    immPregrantedCreditLimitVariation: state.creditPregrantedLimitVariation
}),
    {
        clear: CreditPregrantedLimitVariationActions.clear,
        setLimit: CreditPregrantedLimitVariationActions.setLimit,
        validateStep: CreditPregrantedLimitVariationActions.validateStep,
        setVisibleStep: CreditPregrantedLimitVariationActions.setVisibleStep,
        //we need to correct this on the future. This is setted this way just for testing UI.
        setNewLimit: CreditPregrantedLimitVariationActions.setNewLimit
    })(withRouter(CreditPregrantedLimitVariationView));
